// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const counter_PHOTOS = ["%(counter)s fotka", "%(counter)s fotky", "%(counter)s fotek"];
export const READ_WHOLE_EXPERIENCE = "\u010cti cel\u00e9 hodnocen\u00ed";
export const READ_WHOLE_REVIEW = "\u010cti cel\u00e9...";
